import React from "react";
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";

const MotionHeader = motion(ModalHeader);
const MotionFooter = motion(ModalFooter);

function ModalLayout({
  children,
  rejectHandler,
  title,
  loading,
  isOpen,
  setIsOpen,
  cancelBtnText,
  successBtnText,
  backHandler,
  hideFooter,
  size = "md",
}) {
  const onClose = () => setIsOpen(false);

  return (
    <Modal
      isCentered
      onClose={onClose}
      isOpen={isOpen}
      motionPreset="slideInBottom"
      size={size}
    >
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent borderRadius="xl" overflow="hidden">
        <MotionHeader
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          fontSize="18px"
          fontWeight="700"
          color="brand.500"
          fontFamily="satoshiBold"
          borderBottom="1px solid"
          borderColor="gray.100"
          py="4"
        >
          {title}
        </MotionHeader>
        <ModalCloseButton top="4" />
        
        <ModalBody py="6">
          <AnimatePresence mode="wait">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.2 }}
            >
              {children}
            </motion.div>
          </AnimatePresence>
        </ModalBody>

        {!hideFooter && (
          <MotionFooter
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            borderTop="1px solid"
            borderColor="gray.100"
            bg="gray.50"
            py="3"
          >
            <Button
              variant="ghost"
              mr={3}
              onClick={backHandler ? backHandler : onClose}
              fontSize="13px"
              fontWeight="600"
            >
              {cancelBtnText || "CLOSE"}
            </Button>
            <Button
              onClick={rejectHandler}
              isLoading={loading}
              loadingText="PROCESSING..."
              bg="brand.500"
              color="white"
              fontSize="13px"
              fontWeight="600"
              px="8"
              _hover={{ bg: "brand.600" }}
            >
              {successBtnText || "CONFIRM"}
            </Button>
          </MotionFooter>
        )}
      </ModalContent>
    </Modal>
  );
}

export default ModalLayout;
